import classnames from "classnames";

import { useComponentInView } from "../../../hooks/useComponentInView";
import useOutputReportStore from "../../../store/OutputReport.store";
import {
  checkZeroData,
  getTransitionSummaryDataset,
} from "../../../utils/helpers/chart";
import TransitionSummaryChart from "./TransitionSummaryChart";
import TransitionSummaryDataTable from "./TransitionSummaryDataTable";

const TransitionSummaryReport = () => {
  const { ref } = useComponentInView();

  const sectionMetadata = useOutputReportStore()["Transition Summary"] || {};
  const data = useOutputReportStore(
    (state) => state.data["Transition Summary"]
  );
  const { sectionKeyKebab, title, data2 } = sectionMetadata;

  if (!data) return null;

  const chartDatasets = getTransitionSummaryDataset(data);

  let isZeroData = false;
  if (chartDatasets) {
    isZeroData = checkZeroData(chartDatasets);
  }

  return (
    <article ref={ref} id="TransitionSummary" className="report-article">
      <header className="section-title report-article__header">
        <h1>Transition Summary</h1>
      </header>

      <div className="report-article__content">
        <section
          className={classnames("report-article__visual", {
            "print-break-after": !isZeroData,
          })}
        >
          <TransitionSummaryChart
            id="report-transition-summary"
            isFullWidth={true}
          />
        </section>
        <section className="report-article__visual">
          <TransitionSummaryDataTable />
        </section>
      </div>
    </article>
  );
};

TransitionSummaryReport.propTypes = {};

TransitionSummaryReport.defaultProps = {};

export default TransitionSummaryReport;
